import { FC } from 'react';
import ParentMenu, { ParentMenuProps } from './ParentMenu';

const MultiNivelMenu: FC<ParentMenuProps> = ({ model, onItemClick }) => (
  <ParentMenu model={model} onItemClick={onItemClick} />
);

export default MultiNivelMenu;
